import { RateAdapter } from "./RateAdapter";

import { PricingService } from "../../lookup/pricing/PricingService";

export class VwapAdapter extends RateAdapter {
  constructor(pricingService: PricingService, dealtMode: boolean) {
    super(pricingService, dealtMode);
  }

  getValue(order: any, columnProperty: string): string {
    if (this.pricingService) {
      if (this.dealtMode) {
        return this.pricingService.getVwapDealt(order);
      }
      return this.pricingService.getVwapBase(order);
    }
    return String(order[columnProperty]);
  }
}
